"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @param params.telephone
 * @param params.lastname
 * @param params.firstname
 * @param params.address1
 * @param params.address2
 * @param params.city
 * @param params.state
 * @param params.zip
 * @param params.country
 *
 * @property {String} telephone
 * @property {String} lastname
 * @property {String} firstname
 * @property {String} address1
 * @property {String} address2
 * @property {String} city
 * @property {String} state
 * @property {String} zip
 * @property {String} country
 * @property {String} customer_name - read only (lastname, firstname)
 * @property {String} phone - alias for telephone
 * @property {String} street1 - alias for address1
 * @property {String} street2 - alias for address2
 * @property {String} postalCode - alias for zip
 * @property {String} zipCode - alias for zip
 */
var Address = /*#__PURE__*/function () {
  function Address() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Address);

    this.lastname = params.lastname || '';
    this.firstname = params.firstname || '';
    this.telephone = params.telephone || params.phone || '';
    this.address1 = params.address1 || params.street1 || '';
    this.address2 = params.address2 || params.street2 || '';
    this.city = params.city || '';
    this.state = params.state || '';
    this.zip = params.zip || params.zipCode || params.postalCode || '';
    this.country = params.country && params.country.slice(0, 2).toUpperCase() || '';
  }

  _createClass(Address, [{
    key: "customer_name",
    get: function get() {
      return "".concat(this.lastname, ", ").concat(this.firstname);
    },
    set: function set(str) {
      var lastname = str.split(' ').slice(1).join(' ');
      var firstname = str.split(' ').slice(0, 1).join(' ');
      this.lastname = lastname || '';
      this.firstname = firstname || '';
    }
  }, {
    key: "name",
    get: function get() {
      return this.customer_name;
    },
    set: function set(str) {
      this.customer_name = str;
    }
  }, {
    key: "phone",
    get: function get() {
      return this.telephone;
    },
    set: function set(str) {
      this.telephone = str;
    }
  }, {
    key: "street1",
    get: function get() {
      return this.address1;
    },
    set: function set(str) {
      this.address1 = str;
    }
  }, {
    key: "street2",
    get: function get() {
      return this.address2;
    },
    set: function set(str) {
      this.address2 = str;
    }
  }, {
    key: "postalCode",
    get: function get() {
      return this.zip;
    },
    set: function set(str) {
      this.zip = str;
    }
  }, {
    key: "zipCode",
    get: function get() {
      return this.zip;
    },
    set: function set(str) {
      this.zip = str;
    }
  }]);

  return Address;
}();

module.exports = Address;